module.exports = __webpack_public_path__ + "static/media/logo-green.c284c5b3.png";